import React from 'react';
import styles from './MedicalRequestsListWrapper.module.scss';
import FlatList from '../../../Base/Components/FlatList';
import MedicalRequestsListItem from '../MedicalRequestsListItem/MedicalRequestsListItem';
import ScrollContainer from '../../../Base/Components/ScrollContainer';
import { Document } from '../../../../graphql/graphql';
import useScrollGuard from '../../../Base/Hooks/useScrollGuard';

interface Props {
	data: Document[];
	isLoading: boolean;
	onRefresh: () => void;
	onLoadMore: () => void;
	hasMoreData: boolean;
}

const wrapperId = 'medicalRequestsWrapper';

const MedicalRequestsList: React.FC<Props> = ({
	data,
	isLoading,
	onRefresh,
	onLoadMore,
	hasMoreData,
}) => {
	const { scrollContainerRef } = useScrollGuard<Document>({
		data,
		isLoading,
		onLoadMore,
		hasMoreData,
	});

	return (
		<ScrollContainer
			wrapperId={wrapperId}
			className={styles.list}
			ref={scrollContainerRef}>
			<FlatList
				onRefresh={onRefresh}
				onLoadMore={onLoadMore}
				data={data}
				isLoading={isLoading}
				hasMoreData={hasMoreData}
				scrollableTargetId={wrapperId}
				renderItem={item => (
					<MedicalRequestsListItem item={item} onDelete={onRefresh} />
				)}
			/>
		</ScrollContainer>
	);
};

export default MedicalRequestsList;
